import { Box, Stack } from "@mui/material";
import { NavigationBar, NavigationBarProps } from "./NavigationBar";
import React from "react";
import { Footer } from "./Footer";
import { PageTopNotification } from "./PageTopNotification";

export function PageLayout(props: {
  children: React.ReactNode;
  navigationBarProps?: NavigationBarProps;
}) {
  return (
    <Stack minHeight={"100vh"}>
      <NavigationBar {...props?.navigationBarProps} />
      <PageTopNotification />
      <Box
        flex={1}
        display={"flex"}
        flexDirection={"column"}
        className={"page-layout-content-wrapper"}
      >
        {props.children}
      </Box>
      <Box>
        <Footer />
      </Box>
    </Stack>
  );
}
